<template>
  <v-card>
    <l-map
      v-if="center"
      ref="map"
      style="height: 300px; width: 100%;"
      :zoom="zoom"
      :center="center"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @update:bounds="boundsUpdated"
    >
      <l-tile-layer
        :name="name"
        :url="url"
        :attribution="attribution"
      >
      </l-tile-layer>
      <l-marker
        :visible="visible"
        :draggable="draggable"
        :lat-lng.sync="position"
        @click="alert('Clicou')"
      ></l-marker>
    </l-map>
    <v-card-text
      class="pt-4"
      style="position: relative;"
    >
      <div class="pl-3">
        <h3 class="display-1 font-weight-light orange--text mb-2">Geolocalize seu posto</h3>
        <div class="font-weight-light title mb-2">
          Tentamos encontrar você pelo endereço<br>
          mas precisamos que você ajuste para finalizarmos.
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        flat
        color="primary"
        @click="confirmarGeoposition"
      >
        Confirmar e continuar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { postosDao } from '@/api'
import { L, LMap, LTileLayer, LMarker } from 'vue2-leaflet'

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
      name: 'OpenTopoMap',
      maxZoom: 18,
      zoom: 17,
      bounds: null,
      center: null,
      position: null,
      draggable: true
    }
  },
  watch: {
    posto (val) {
      if (val !== null && val !== undefined) {
        if (this.posto.latitude && this.posto.longitude) {
          this.carregarMapa(this.posto.latitude, this.posto.longitude)
        } else {
          if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
              this.carregarMapa(position.coords.latitude, position.coords.longitude)
            })
            /* geolocation is available */
          } else {
            alert('Não é possível acessar a geolocalização do seu dispositivo.')
          }
        }
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    visible () {
      return !!this.position
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    zoomUpdated (zoom) {
      this.zoom = zoom
    },
    centerUpdated (center) {
      this.center = center
    },
    boundsUpdated (bounds) {
      this.bounds = bounds
    },
    carregarMapa (latitude, longitude) {
      this.position = L.latLng(latitude, longitude)
      this.center = L.latLng(latitude, longitude)
      setTimeout(function () { window.dispatchEvent(new Event('resize')) }, 250)
    },
    confirmarGeoposition () {
      this.$store.commit('setLoading', true)

      let body = {
        cnpj: this.posto.cnpj,
        latitude: this.position.lat,
        longitude: this.position.lng
      }

      postosDao.geolocatePosto(body, this.headers).then(response => {
        this.$store.commit('setLoading', false)
        if (response.ok) {
          this.$store.dispatch('geoposicionarPosto', this.position)
        } else {
          this.$store.commit('setError', { message: 'Não foi possível atualizar a gelocalização do posto' })
        }
      })
    }
  },
  mounted () {
    if (this.posto) {
      if (this.posto.latitude && this.posto.longitude) {
        this.carregarMapa(this.posto.latitude, this.posto.longitude)
      } else {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.carregarMapa(position.coords.latitude, position.coords.longitude)
          })
          /* geolocation is available */
        } else {
          alert('Não é possível acessar a geolocalização do seu dispositivo.')
        }
      }
    }
  }
}
</script>
